import { NgModule } from '@angular/core';
import { PRODUCT_SEARCH_PAGE_NORMALIZER } from '@spartacus/core';
import { ProductSearchBreadcrumbsNormalizer } from './product-search-breadcrumbs-normalizer';

@NgModule({
  providers: [
    {
      provide: PRODUCT_SEARCH_PAGE_NORMALIZER,
      useExisting: ProductSearchBreadcrumbsNormalizer,
      multi: true,
    },
  ],
})
export class SearchConvertersModule {}
